import { render, staticRenderFns } from "./addLockGoods.vue?vue&type=template&id=4d8a03f6&scoped=true&"
import script from "./addLockGoods.vue?vue&type=script&lang=js&"
export * from "./addLockGoods.vue?vue&type=script&lang=js&"
import style0 from "./addLockGoods.vue?vue&type=style&index=0&id=4d8a03f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a03f6",
  null
  
)

export default component.exports